<!-- <div class="comment-thread" [ngStyle]="{ left: x + 'px', top: y + 'px' }">
  <div *ngFor="let comment of comments" class="comment-block">
    <div class="comment-header">
      {{ comment.time | date: 'short' }}
    </div>
    <div class="comment-body">
      {{ comment.text }}
    </div>
  </div>
</div> -->
<div class="comment-thread" [ngStyle]="{ left: x + 'px', top: y + 'px' }">
  <div *ngFor="let comment of comments" class="comment-block">
    <div class="comment-header flex-row space-between">
      <div>
        {{ comment.userName }}
      </div>
      <div>
        {{ comment.time | date: 'short' }}
      </div>
    </div>
    <div class="comment-body">
      {{ comment.text }}
    </div>
  </div>
  <div class="new-comment comment-block flex-row gap-4">
    <textarea
      #currentComment
      [(ngModel)]="draft"
      placeholder="Add comment"
      (input)="autoResizeTextarea()"
      (keyup)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()"
      (keydown)="handleKeydown($event)"
      style="overflow: hidden; resize: none"
    ></textarea>
    <nw-icon type="keyboard_return" (click)="handleIconClick()"></nw-icon>
  </div>
</div>
